var _path, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutpmationlineleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 124,
    viewBox: "0 0 326 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H185.007C193.864 0.5 201.666 6.32466 204.183 14.8159L231.267 106.184C233.784 114.675 241.586 120.5 250.442 120.5H325",
    stroke: "url(#paint0_linear_568_4)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 323,
    cy: 120.5,
    r: 3,
    fill: "url(#paint1_linear_568_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_568_4",
    x1: 0,
    y1: 0.5,
    x2: 77.9838,
    y2: 211.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_568_4",
    x1: 320,
    y1: 117.5,
    x2: 326.222,
    y2: 117.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutpmationlineleft);
export default __webpack_public_path__ + "static/media/autpmationlineleft.980ed59aa4c17ae040cef00e766af96e.svg";
export { ForwardRef as ReactComponent };